import React from "react";
import background from "./images/background.png";

const isInStandaloneMode = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

const About = () => {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <div
      className="min-h-full px-6 py-16 font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="max-w-2xl mx-auto text-center space-y-5 px-5 py-6"
        style={{
          background: "rgba(255,255,255,0.92)",
          borderRadius: "20px",
          border: "2px solid #f9a8d4",
          boxShadow: "0 8px 32px rgba(176,106,179,0.12)",
        }}
      >
        <h1 className="text-lg font-bold" style={{ color: "#b06ab3" }}>
          ¿Y esta joya quién la hizo? ✨
        </h1>

        <p className="text-sm leading-relaxed" style={{ color: "#6b7280" }}>
          Hola, soy{" "}
          <span className="font-semibold italic" style={{ color: "#2d1f3d" }}>
            Mely
          </span>
          , y esta app nació del cariño, la inspiración y las ganas de crear
          algo muy especial para Karime 🩵
        </p>

        <p className="text-sm leading-relaxed" style={{ color: "#6b7280" }}>
          Desde sus frases hasta sus momentos más icónicos, cada parte fue
          diseñada para celebrar lo que hace única a Karime: su autenticidad, su
          humor y su empoderamiento ✨
        </p>

        <p className="text-sm leading-relaxed" style={{ color: "#6b7280" }}>
          No soy parte de su equipo (quisiése, bb! 😜), solo una fan creativa
          que necesitaba sacar esta inspiración al mundo.
        </p>

        <p className="text-xs italic" style={{ color: "#9b7eaa" }}>
          🛠️ ¿Viste un bug o tienes feedback bonito?{" "}
          <a
            href="/feedback"
            style={{ color: "#b06ab3" }}
            className="underline"
          >
            Puedes mandármelo aquí
          </a>
        </p>
      </div>

      <div className="flex flex-col items-center gap-3 mt-5">
        <span
          className="text-sm font-semibold text-center"
          style={{ color: "#7a6080" }}
        >
          Sigue a KarimeSays en redes para más contenido y sorpresas 🩵
        </span>
        <div className="flex gap-4 mt-2">
          <a
            href="https://www.instagram.com/karimesaysapp/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-black rounded-full w-10 h-10 flex items-center justify-center hover:scale-110 transition-transform"
            onClick={(e) => {
              if (isIOS && isInStandaloneMode()) {
                e.preventDefault();
                window.location.href =
                  "instagram://user?username=karimesaysapp";
                setTimeout(
                  () =>
                    window.open(
                      "https://www.instagram.com/karimesaysapp/",
                      "_blank"
                    ),
                  600
                );
              }
            }}
          >
            <img
              src="/icons/instagram.svg"
              alt="Instagram"
              className="w-5 h-5 invert"
            />
          </a>
          <a
            href="https://www.tiktok.com/@karime.says.app"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-black rounded-full w-10 h-10 flex items-center justify-center hover:scale-110 transition-transform"
          >
            <img
              src="/icons/tiktok.svg"
              alt="TikTok"
              className="w-5 h-5 invert"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
